import { render, staticRenderFns } from "./six.html?vue&type=template&id=6bcf4333&external"
import script from "./six.vue?vue&type=script&lang=js"
export * from "./six.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports